import { render, staticRenderFns } from "./myRequestServiceList.vue?vue&type=template&id=76b71e66"
import script from "./myRequestServiceList.vue?vue&type=script&lang=js"
export * from "./myRequestServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports